module.exports = __webpack_public_path__ + "../resources/img/member_img1.1dfdf144.png";